import { MultiSelect } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { useSearch } from '../../providers';
import { UpdateDate } from '../../types';
import { AdvancedSearchFilterUpdatedDateRadioGroup } from './AdvancedSearchFilterUpdatedDateRadioGroup';

export const AdvancedSearchFilterUpdatedDate = () => {
  const UPDATED = I18n.t('js.learner.advanced_search.filters.updated');
  const LAST_7_DAYS = I18n.t('js.learner.advanced_search.filters.last_7_days');
  const LAST_30_DAYS = I18n.t('js.learner.advanced_search.filters.last_30_days');
  const LAST_YEAR = I18n.t('js.learner.advanced_search.filters.last_year');
  const ALL_TIME = I18n.t('js.learner.advanced_search.filters.all_time');

  const options = {
    last_7_days: LAST_7_DAYS,
    last_30_days: LAST_30_DAYS,
    last_year: LAST_YEAR,
    all_time: ALL_TIME,
  };

  const { filterUpdatedDate, updateFilterUpdatedDate } = useSearch();

  return (
    <MultiSelect
      label={options[filterUpdatedDate] || UPDATED}
      title={UPDATED}
      onClear={() => updateFilterUpdatedDate(UpdateDate.ALL_TIME)}
    >
      <AdvancedSearchFilterUpdatedDateRadioGroup
        filterUpdatedDate={filterUpdatedDate}
        setFilterUpdatedDate={updateFilterUpdatedDate}
      />
    </MultiSelect>
  );
};
